import moment from 'moment'

export function normalizarPesquisa(item) {
  return {
    ...item,
    redirecionar: item.ultima_pco_tarefa_id ? `/workflow/ficha-tecnica-tarefa/${item.ultima_pco_tarefa_id}` : null,
    data_fechamento: item?.provedor_recuperacao?.fechamento?.data_fechamento ? 
                  moment(item.provedor_recuperacao.fechamento.data_fechamento).format('DD/MM/YYYY') : '—',
    data_abertura: item?.provedor_recuperacao?.data_abertura_ticket ? moment(item.provedor_recuperacao.data_abertura_ticket).format('DD/MM/YYYY') : '—',
    centro_funcional: item?.provedor_recuperacao?.centro_funcional ?? item?.centro_funcional ?? null,
  }
}
